import tree from "./images/tree.png";
import house from "./images/house.png";
import school from "./images/school.png";
import children from "./images/children.png";

const list = [
    {
        id: 1,
        title: "The House",
        para: "Representing the provision of shelter and protection to the homeless as well as oneness.",
        img: house
    },
    {
        id: 2,
        title: "The Tree",
        para: "Standing for the shade of security and tranquil led atmosphere provided to the beneficiaries of the organization. Also a symbol of growth and protection.",
        img: tree
    },
    {
        id: 3,
        title: "Graduation Kit",
        para: "Representing quality, sustainable and competitive education to be offered by The Fidel Foundation. ",
        img: school
    },
    {
        id: 4,
        title: "Playing Children",
        para: "They speak of the peaceful environment that enables children and the youths to live freely and explore their talents to the maximum. ",
        img: children
    }
];

export default list;